/* eslint-disable max-len */
import axios from "axios";
import { getUserAndPremiseId } from "../utils";
let userData =
  JSON.parse(localStorage.getItem("userinfo")) ||
  JSON.parse(sessionStorage.getItem("userinfo"));
const getUserInfo = getUserAndPremiseId();
const userId = getUserInfo?.userId;

const premiseId = getUserInfo?.premiseId;

const API = {
  Api: (url) => {
    return {
      NodeGetWithPremise: (params) =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
            params: {
              ...params,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),

      NodePutPremiseIdHeader: (data) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),

      NodePostPremiseIdHeader: (data) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      getWithoutBearer: () =>
        axios
          .get(url, {
            headers: {
              Authorization: userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      get: () =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      getCustomToken: (token) =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + token || userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      getWithHeader: () =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              request_header_inbound_policy: "allow",
              // "ngrok-skip-browser-warning": "true"
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return { response: error.response, status: false };
          }),
      getWithNoToken: () =>
        axios
          .get(url, {
            headers: {},
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      getWithPremiseHeader: () =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              token: userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      getWithUserNPremiseHeader: () =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              "USER-ID": userId,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return { response: error.response, status: false };
          }),
      getWithPremiseIdHeader: () =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return { response: error.response, status: false };
          }),
      getWithAllHeaders: () =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              "USER-ID": userId,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              token: userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return { response: error.response, status: false };
          }),
      getCustomHeader: (headers) =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              // Authorization:
              //   "Bearer " +
              //   "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW1vLmh1Ym9wc2JlbmdhbHVydUBzaHJlZW1hcnV0aWNvdXJpZXIuY29tIiwiYXV0aG9yaXRpZXMiOlt7ImF1dGhvcml0eSI6IlJPTEVfQ1BBRE1JTiJ9XSwiaXNzIjoiaHR0cDovL3NtY3MtZGV2Lmh1dGVjaHdlYi5jb20vc21jcy13ZWJhcHAiLCJqdGkiOiIxMzUxN2RlNi1lMGNkLTRmMWUtYjM5ZS0wNTcwZmZlNjI2MDYiLCJpYXQiOjE3MzgzMDgyMDAsImV4cCI6MTczODMzNzAwMH0.oYAdiMYUCPZKXCUHEh3inDcRB_FQZNeLqFuu06DKyW4",
              ...headers,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })

          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return { response: error.response, status: false };
          }),

      getWithToken: (token) =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),

      getwithParams: (params, customHeader) =>
        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              "USER-ID": userId,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              ...customHeader,
            },
            params: {
              ...params,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return {
              response: error.response,
              status: false,
              newtwork: error.code == "ERR_NETWORK",
            };
          }),
      getWithResponseType: () =>
        axios.get(url, {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + userData?.accessToken,
          },
        }),
      post: (data) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      postWithHeader: (data) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              token: userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      postCustomHeader: (data, headers) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...headers,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      postWithPrmiseHeader: (data) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),

      postIdHeader: (data) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      postIdTokenHeader: (data) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
              token: userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      postIdCustomHeader: (data, headers) =>
        axios
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
              ...headers,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            if (error?.response?.status == 401) {
              let showNotice = localStorage.getItem("showNotice"); // Save before clearing

              localStorage.clear();
              sessionStorage.clear();
              document.cookie = "userToken=";

              localStorage.setItem("showNotice", showNotice);
              window.location.assign("/");
            }
            return { response: error.response, status: false };
          }),
      postWithResponseType: (data) =>
        axios.post(url, data, {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + userData?.accessToken,
          },
        }),
      put: (data) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      putCustomHeader: (data, headers, params) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...headers,
            },
            params: params,
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      putCustomIdHeader: (data, customHeader) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
              ...customHeader,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      putWithHeader: (data) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              token: userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      putIdHeader: (data) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      putPremiseIdHeader: (data) =>
        axios
          .put(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      patch: (data) =>
        axios
          .patch(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      patchCustomHeader: (data, headers) =>
        axios
          .patch(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...headers,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      patchIdHeader: (data) =>
        axios
          .patch(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      patchIdTokenHeader: (data) =>
        axios
          .patch(url, data, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              token: userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
            },
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      deleteIdHeader: (data) =>
        axios
          .delete(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
              ...(premiseId && {
                "SMCS-PREMISE-ID": premiseId,
              }),
              "USER-ID": userId,
            },
            data,
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
      deleteHeader: (data) =>
        axios
          .delete(url, {
            headers: {
              Authorization: "Bearer " + userData?.accessToken,
            },
            data,
          })
          .then((response) => {
            return { response: response, status: true };
          })
          .catch((error) => {
            return { response: error.response, status: false };
          }),
    };
  },
  ApiWithAuth: (url, token) => {
    return {
      get: () =>
        axios
          .get(url, {
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
              Authorization: token,
            },
          })
          .then((response) => {
            return response?.data;
          })
          .catch((error) => {
            return error.response;
          }),
      post: (data) =>
        axios
          .post(url, data, {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
              Authorization: token,
            },
          })
          .then((response) => {
            return response?.data;
          })
          .catch((error) => {
            return error.response;
          }),
    };
  },
};
export default API;
